import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ForwardIcon from '@mui/icons-material/Forward';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Card, CardContent, IconButton, TextField, Tooltip } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Fade from '@mui/material/Fade';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';

export const ViewMilestoneQuery: React.FunctionComponent<any> = ({
  queryKeys,
  queryType,
  totalFieldQueries,
  fieldQueries,
  setQueryType,
  perDisable,
  expanded,
  handleChangeAccordion,
  anchorEl,
  openMore,
  handleClick,
  handleCloseMore,
  resTexts,
  setResTexs,
  sendQueryRes,
  handleTextChange,
  setDeleteType,
  handleDialoBox,
  currentId,
  setForwardQuery,
  setCurrentId,
  handleForwardDialogBox,
  setConfirmDailog,
  setResloveQueryId
}) => {
  const { checkPermission } = usePermissionWrapper();
  const { selectedApp } = useSelectedAppInfo();
  const viewRaiseQuery = () => {
    setForwardQuery(true);
    setQueryType('Field');
  };

  return (
    <Box sx={{ width: '100%'}}>
      <Grid container spacing={0} sx={{ alignItems: 'center'}} mb={2}>
        <Grid item md={6}>
          <h2>Query</h2>
        </Grid>
        <Grid item md={6}>
          <Button
            disabled={
              selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG
                ? !checkPermission('raise_query_milestone')
                : !checkPermission('raise_startup_query_milestone')
            }
            variant="contained"
            onClick={viewRaiseQuery}
            sx={{ float: 'right'}}
          >
            Raise Query
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={0}>
        <Grid item md={12}>
          <Box sx={{ mb: 2, width: '100%' }}>
            <Grid container>
              <Grid item md={12}>
                {totalFieldQueries == 0 ? (
                  <>
                    <br />
                    <br />
                    <Typography variant="body1" component="div" sx={{ textAlign: 'center', color: 'rgba(0,0,0,0.6)' }}>
                      There are no queries at the moment
                    </Typography>
                    <br />
                    <br />
                  </>
                ) : (
                  <Typography variant="h6" component="div" sx={{ mb: 1 }} className="h6-fs16">
                    Field Queries ({totalFieldQueries})
                  </Typography>
                )}
              </Grid>
            </Grid>
            {fieldQueries &&
              fieldQueries.map((queryObj: any) => {
                if (
                  (queryKeys.is_all_field_queries === true &&
                    queryType != 'Field' &&
                    (queryType == 'ALL' || queryType == queryObj.query.report_query_type || queryType == 'Forward') &&
                    queryObj.query.report_query_type !== 'Section' &&
                    queryObj.query.report_section_name == queryKeys.report_section_name &&
                    queryKeys.section_field_names?.includes(queryObj.query.report_field_name)) ||
                  ((queryType == 'ALL' || queryType == queryObj.query.report_query_type || queryType == 'Forward') &&
                    queryObj.query.report_query_type !== 'Section' &&
                    ((queryObj.query.report_section_name == 'MileStone' &&
                      queryObj.query.report_section_name == queryKeys.report_section_name &&
                      queryObj.query.report_id == queryKeys.id) ||
                      (queryObj.query.report_section_name !== 'MileStone' &&
                        queryObj.query.report_section_name == queryKeys.report_section_name &&
                        queryObj.query.report_field_name == queryKeys.report_field_name)))
                ) {
                  return (
                    <Grid container key={queryObj.query.id}>
                      <Grid md={12}>
                        <Card className="query-card">
                          <CardContent>
                            <Grid container sx={{ pb: 2 }}>
                              <Grid item md={8} className="name-section">
                                <AccountCircleIcon />
                                {queryObj.query.created_by}
                                <span>
                                  {new Date(queryObj.query.created_on)
                                    .toLocaleDateString('en-US', {
                                      hour: 'numeric',
                                      minute: '2-digit',
                                      hour12: true
                                    })
                                    .replace(/,/g, '')}
                                </span>
                                <Chip
                                  label={`${queryObj.query.report_query_type} Query`}
                                  color="success"
                                  size="small"
                                />
                              </Grid>
                              <Grid item md={4} className="more-section" display="flex" justifyContent="flex-end">
                                <Tooltip
                                  placement="top"
                                  title={
                                    queryObj.query.report_is_opened == false ? 'Resolved Query' : 'Unresolved Query'
                                  }
                                >
                                  <span>
                                    <Button
                                      title="Unresolved Query"
                                      disabled={queryObj.query.report_is_opened == false || !perDisable}
                                      className="grey-btn"
                                      onClick={() => {
                                        setConfirmDailog(true);
                                        setResloveQueryId(queryObj.query.id);
                                      }}
                                    >
                                      {queryObj.query.report_is_opened == false ? (
                                        <CheckCircleIcon sx={{ fill: '#41B487 !important' }} />
                                      ) : (
                                        <CheckCircleOutlineIcon />
                                      )}
                                    </Button>
                                  </span>
                                </Tooltip>
                                <div>
                                  {perDisable ? (
                                    <Tooltip placement="top" title="More Options">
                                      <IconButton
                                        disabled={queryObj.query.report_is_opened == false}
                                        id="fade-button"
                                        aria-controls={openMore ? 'fade-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={openMore ? 'true' : undefined}
                                        onClick={e => {
                                          setCurrentId(queryObj.query.report_field_query_id_v);
                                          handleClick(e);
                                        }}
                                        sx={{ fill: '#41B487 !important' }}
                                      >
                                        <MoreHorizIcon />
                                      </IconButton>
                                    </Tooltip>
                                  ) : (
                                    <></>
                                  )}
                                  <Menu
                                    id="fade-menu"
                                    MenuListProps={{
                                      'aria-labelledby': 'fade-button'
                                    }}
                                    anchorEl={anchorEl}
                                    open={openMore && currentId == queryObj.query.report_field_query_id_v}
                                    onClose={handleCloseMore}
                                    TransitionComponent={Fade}
                                    className="remove-menu"
                                    anchorOrigin={{
                                      vertical: 'bottom',
                                      horizontal: 'right'
                                    }}
                                    transformOrigin={{
                                      vertical: 'top',
                                      horizontal: 'right'
                                    }}
                                  >
                                    {checkPermission('delete_query_milestone') ? (
                                      <MenuItem
                                        disabled={!checkPermission('delete_query_milestone')}
                                        onClick={() => {
                                          setDeleteType('Field');
                                          handleDialoBox(queryObj.query.report_field_query_id_v);
                                        }}
                                      >
                                        <DeleteIcon /> Remove
                                      </MenuItem>
                                    ) : (
                                      <></>
                                    )}
                                    {perDisable ? (
                                      <MenuItem
                                        onClick={() => {
                                          setQueryType('Forward');
                                          handleForwardDialogBox(
                                            queryObj.query.report_field_query_id_v,
                                            queryObj.query.report_send_to,
                                            queryObj.query.id
                                          );
                                        }}
                                      >
                                        <ForwardIcon /> Forward
                                      </MenuItem>
                                    ) : (
                                      <></>
                                    )}
                                  </Menu>
                                </div>
                              </Grid>
                              <Grid item md={12}>
                                <span className="sub-text"><strong>ID:</strong> {queryObj.query.report_field_query_id_v}</span>
                                <span className="sub-text"><strong>Field:</strong> {queryObj.query.report_field_label}</span>
                                <span className="sub-text">
                                  <strong>{queryObj.query.report_forward_to != '' ? 'Initially Sent To' : 'Send To'}:</strong>{' '}
                                  {queryObj.query.report_send_to}
                                </span>
                                {queryObj.query.report_forward_to != '' && (
                                  <span className="sub-text"><strong>Forwarded To:</strong> {queryObj.query.report_forward_to}</span>
                                )}
                                <span className="sub-text"><strong>Message:</strong> {queryObj.query.report_comment}</span>
                              </Grid>
                            </Grid>

                            <Grid container>
                              <Grid item md={12}>
                                <Accordion
                                  expanded={expanded === queryObj.query.report_field_query_id_v}
                                  onChange={handleChangeAccordion(queryObj.query.report_field_query_id_v)}
                                  className="CustomAccordion-AH"
                                  sx={{ mb: 0, 
                                        '& .MuiAccordionSummary-expandIconWrapper': { alignSelf: 'center !important', marginTop: 0},
                                        '& .MuiAccordionSummary-content': { marginBottom: 0}
                                      }}
                                >
                                  {perDisable ? (
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel2bh-content"
                                      id="panel2bh-header"
                                      sx={{ mb: 0 }}
                                    >
                                          <Typography variant="h6" component="div" sx={{ mb: 0}}>
                                            {queryObj.responses && queryObj.responses.length} COMMENT
                                            {queryObj.responses && queryObj.responses.length > 1 ? 'S' : ''}
                                          </Typography>
                                    </AccordionSummary>
                                  ) : (
                                    <></>
                                  )}
                                  <AccordionDetails>
                                    <Grid container>
                                      {queryObj.responses &&
                                        queryObj.responses.map((res: any) => {
                                          return (
                                            <div key={res.id} style={{ width: '100%' }}>
                                              <Grid item md={12} className="name-section" sx={{ pl: 2 }}>
                                                <AccountCircleIcon /> {res.created_by}
                                                <span>
                                                  {new Date(res.created_on)
                                                    .toLocaleDateString('en-US', {
                                                      hour: 'numeric',
                                                      minute: '2-digit',
                                                      hour12: true
                                                    })
                                                    .replace(/,/g, '')}
                                                </span>
                                              </Grid>
                                              <Grid item md={12} sx={{ pl: 2.5, mb: 2, wordBreak: 'break-all' }}>
                                                <span className="sub-text">{res.query_response}</span>
                                              </Grid>
                                            </div>
                                          );
                                        })}
                                      {queryObj.query.report_is_opened ? (
                                        <Grid container className="action-section">
                                          <Grid item md={12}>
                                            <FormControl fullWidth margin="normal" className="response-input">
                                              <TextField
                                                disabled={
                                                  queryObj.query.report_is_opened == false &&
                                                  selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG
                                                    ? !checkPermission('respond_query_milestone')
                                                    : !checkPermission('respond_startup_query_milestone')
                                                }
                                                error={resTexts[queryObj.query.id] == ''}
                                                helperText={resTexts[queryObj.query.id] == '' ? 'Required!' : ' '}
                                                id="standard-disabled"
                                                label="Response"
                                                variant="standard"
                                                inputProps={{ maxLength: 200 }}
                                                value={
                                                  resTexts[queryObj.query.id] == undefined
                                                    ? ''
                                                    : resTexts[queryObj.query.id]
                                                }
                                                onChange={e => handleTextChange(e, queryObj.query.id)}
                                                onKeyDown={e => {
                                                  e.stopPropagation();
                                                }}
                                              />
                                            </FormControl>
                                            <Button
                                              disabled={
                                                queryObj.query.report_is_opened == false &&
                                                selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG
                                                  ? !checkPermission('respond_query_milestone')
                                                  : !checkPermission('respond_startup_query_milestone')
                                              }
                                              onClick={() => {
                                                if (
                                                  resTexts[queryObj.query.id] != undefined &&
                                                  resTexts[queryObj.query.id] !== ''
                                                ) {
                                                  sendQueryRes(queryObj.query.id);
                                                } else {
                                                  const newObj = { ...resTexts };
                                                  newObj[queryObj.query.id] = '';
                                                  setResTexs(newObj);
                                                }
                                              }}
                                              variant="text"
                                              className={
                                                queryObj.query.report_is_opened == false ||
                                                !checkPermission('respond_query_milestone') ||
                                                !checkPermission('respond_startup_query_milestone')
                                                  ? 'grey-btn-link'
                                                  : ''
                                              }
                                            >
                                              Send
                                            </Button>
                                          </Grid>
                                        </Grid>
                                      ) : (
                                        <Typography component="div" sx={{ color: 'red' }}>
                                          Comments are closed
                                        </Typography>
                                      )}
                                    </Grid>
                                  </AccordionDetails>
                                </Accordion>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  );
                }
              })}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
